module.exports = __webpack_public_path__ + "img/cole-keister-1407447-unsplash.353a40aa.jpg";